// Match Activities' user-local date semantics, including its UTC fallback for
// invalid/unsupported profile zones. An omitted zone uses the device timezone.
export const coachDayKey = (date, timeZone) => {
  try {
    return new Date(date).toLocaleDateString('en-CA', { timeZone });
  } catch {
    return new Date(date).toISOString().slice(0, 10);
  }
};
